@if (title) {
    <ds-card-header surface="lowest" msThemedCardHeader class="fixture-header" [themedSurface]="themeHeaderSurface">
        @if (isFavouritesEnabled && showFavoriteToggle && league && sport) {
            <span slot="start">
                <ms-favourite-league-toggle [name]="league.name" [id]="league.id" [sport]="sport.id" />
            </span>
        }
        <h1 slot="title" class="league-heading-title" [class.tournament-heading-title]="isTournament">{{ title }}</h1>
        @if (sport && league) {
            <div class="league-heading-info" slot="title">
                <ms-competition-logo [sportId]="sport.id" [leagueId]="league.id" [imageProfile]="league.imageProfile" />
            </div>
        }
        <ng-container [ngTemplateOutlet]="offerBadgeTemplate || defaultOfferBadgeTemplate" />
    </ds-card-header>
}
<ng-content />

@if (tabs.length) {
    <ms-tab-group-counter
        class="fixture-list-tabs"
        indicator="underline"
        size="small"
        [showBorder]="false"
        [tabs]="tabs"
        (tabSelected)="changed($event)" />
} @else if (pills.length) {
    <ms-widget-pill [pills]="pills" (select)="changedPill($event)" />
}
<ng-template #defaultOfferBadgeTemplate>
    @if (sport && league && leagueIds) {
        <ms-reward-token-eligible-tag [sport]="sport.id" [leagues]="leagueIds" />
    }
</ng-template>
